import ApiService from './ApiService';

class ConnectionService {
  constructor() {
    this.apiService = new ApiService(process.env.REACT_APP_BIG_QUERY_URL);
  }

  async getConnectionReasons(userProfile, linkedinProfile, connectingPoints) {
    try {
      const response = await this.apiService.post('/get-reasons/', {
        userprofile: userProfile,
        linkedin_profile: linkedinProfile,
        connecting_points: connectingPoints
      });

      // The response can be a string or an object with a 'response' property.
      // Handle both cases to avoid errors.
      if (typeof response === 'string') {
        return response;
      }
      if (response && response.response) {
        return response.response;
      }
      // If the response is in an unexpected format, return it as is
      // and let the calling function handle it. This prevents throwing
      // an unnecessary error when the API returns a valid but
      // differently structured response.
      return response;
    } catch (error) {
      console.error('Error getting connection reasons:', error);
      throw error;
    }
  }

  async getMatchReasons(searchQuery, profile, matchedKeywords) {
    try {
      const response = await this.apiService.post('/get-match-reasons/', {
        search_query: searchQuery,
        profile: profile,
        matched_keywords: matchedKeywords
      });

      if (response.match_reasons) {
        return response.match_reasons;
      }
      throw new Error('Failed to get match reasons');
    } catch (error) {
      console.error('Error getting match reasons:', error);
      throw error;
    }
  }

}

export default new ConnectionService();
